module.exports = __webpack_public_path__ + "img/12310c536d9da4d383ee58eb43ef3d42.b7598766.jpg";